import type { ChatAssetItem } from "schemas/generated/chatMessage";

import React from "react";

export const AssetToken = ({ data }: { data: ChatAssetItem }) => {
  return (
    <span className="inline-flex items-center align-bottom pt-1 max-w-full">
      <img
        src={data.url}
        alt={data.name}
        className="w-5 h-5 object-cover rounded-sm inline align-baseline mr-1 border border-border"
      />
      <span className="font-medium text-default truncate">
        {data.name}.{data.fileExtension}
      </span>
    </span>
  );
};
